import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FederalSubjectsService } from '@app/core/services';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { City } from '@app/entity/city';

interface CityInput {
  [cityId: number]: string[];
}

@Component({
  selector: 'app-voucher-city-input',
  templateUrl: './voucher-city-input.component.html',
  styleUrls: ['./voucher-city-input.component.scss'],
})
export class VoucherCityInputComponent implements OnInit {
  @Input() locations: CityInput = [];
  locationsKeys = [];
  form: FormGroup;

  constructor() { }

  ngOnInit() {
  }

  addLocation() {
    this.locations[0] = ['', ];
    this.locationsKeys = Object.keys(this.locations);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/voucher-city-input/voucher-city-input.component.ts